/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import logo from '../../assets/images/home-logo.png';
import logosoh from '../../assets/images/home-logo-soh.png';
import logowim from '../../assets/images/home-logo-wim.png';

const LogoWrapper = styled.div`
	max-width: 475px;
	padding-bottom: 25px;
`;

const getLogo = () => {
    switch (process.env.CLIENT) {
        case 'soh':
            return logosoh;
        case 'wim':
            return logowim;
        default:
            return logo;
    }
}

const Logo = () => (
    <LogoWrapper>
        <img src={getLogo()} alt="Customer Logo"/>
    </LogoWrapper>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/logo/index.js